import React from 'react';
import RelayService from '../service/RelayService';
import { QueryRenderer, graphql } from 'react-relay';
import SellerGroupModelList from './SellerGroupModelList';
import WebIntlProvider from '../ui/i18n/WebIntlProvider';

export default class SellerGroupModelListLoader extends React.Component {

  render() {
    return (
      <div className="seller-product-group-list-container">
        <QueryRenderer
          environment={RelayService.environment}
          query={graphql`
            query SellerGroupModelListLoaderQuery {
                searchSeller {
                    ...SellerGroupModelList_searchSeller
                }
            }
          `}
          variables={{
            sellerContactId: this.props.sellerContactId,
            sellerModelId: this.props.sellerModelId
          }}
          render={({ error, props }) => {
              if (error) {
                // console.log("SellerGroupModelListLoader: @render-error: " + error);
                return <div>{error.message}</div>;
              } else if (props) {
                // console.log("SellerGroupModelListLoader: @render-props: ", props);
                return (
                  <WebIntlProvider>
                    <SellerGroupModelList sellerContactId={this.props.sellerContactId} sellerModelId={this.props.sellerModelId} searchSeller={props.searchSeller}/>
                  </WebIntlProvider>)
              }
              return <div>Loading</div>
            }
          }
        >

        </QueryRenderer>
      </div>)
  }
}

